import { render, staticRenderFns } from "./OnboardingCompanyExtraCosts.vue?vue&type=template&id=11ea6344"
import script from "./OnboardingCompanyExtraCosts.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyExtraCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports